export const getNormalizedIsoDate = (
	timestamp: string = new Date().toISOString()
) => {
	const { date, offset } =
		/(?<date>\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}(?:\d{3})?)(?<offset>Z|(?:\+|\-)\d{2}:\d{2})?/.exec(
			timestamp
		)?.groups ?? {};
	return {
		iso: `${date}${offset ?? 'Z'}`,
		offset,
		millis: date.split('.')[1],
	};
};
